/**
 * AquaFlavor — 3D & Animation Controller
 * Handles: model-viewer scroll orbit, reveal animations, FAQ accordion, sticky ATC bar
 */

(function () {
  'use strict';

  /* ─── SCROLL REVEAL ───────────────────────────────────── */
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('af-reveal--visible');
          revealObserver.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('.af-reveal').forEach((el) => revealObserver.observe(el));

  /* ─── MODEL-VIEWER SCROLL ORBIT ──────────────────────── */
  const viewer = document.querySelector('.af-model-viewer');
  if (viewer) {
    const HERO_HEIGHT = document.querySelector('.af-hero')?.offsetHeight || 700;
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const progress = Math.min(window.scrollY / HERO_HEIGHT, 1);
        // Rotate from 0° to 45° as user scrolls through hero
        const yDeg = progress * 45;
        // Slight tilt for depth
        const xDeg = 10 + progress * 8;
        viewer.setAttribute('camera-orbit', `${yDeg}deg ${xDeg}deg 2.2m`);
        ticking = false;
      });
    }, { passive: true });
  }

  /* ─── HERO PARTICLE GLOW (pure CSS-driven, JS triggers) ─ */
  const hero = document.getElementById('af-top');
  if (hero) {
    hero.addEventListener('mousemove', (e) => {
      const rect = hero.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      hero.style.setProperty('--mouse-x', `${x}%`);
      hero.style.setProperty('--mouse-y', `${y}%`);
    });
  }

  /* ─── FAQ ACCORDION ──────────────────────────────────── */
  document.querySelectorAll('.af-faq-q').forEach((q) => {
    const answer = q.nextElementSibling;
    if (!answer) return;

    // Start closed
    answer.style.maxHeight = '0';
    answer.style.overflow = 'hidden';
    answer.style.transition = 'max-height 0.35s ease, opacity 0.3s ease';
    answer.style.opacity = '0';

    q.addEventListener('click', () => {
      const isOpen = q.classList.contains('af-faq-open');
      // Close all
      document.querySelectorAll('.af-faq-q.af-faq-open').forEach((openQ) => {
        openQ.classList.remove('af-faq-open');
        const a = openQ.nextElementSibling;
        if (a) { a.style.maxHeight = '0'; a.style.opacity = '0'; }
      });
      if (!isOpen) {
        q.classList.add('af-faq-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        answer.style.opacity = '1';
      }
    });
  });

  /* ─── STICKY ATC BAR ─────────────────────────────────── */
  const stickyBar = document.getElementById('af-sticky-atc');
  const heroSection = document.getElementById('af-top');

  if (stickyBar && heroSection) {
    const stickyObserver = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle('af-sticky-atc--visible', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    stickyObserver.observe(heroSection);
  }

  /* ─── URGENCY STOCK COUNTER ANIMATION ───────────────── */
  const stockEl = document.querySelector('.af-stock-count');
  if (stockEl) {
    stockEl.classList.add('af-stock-pulse');
  }

  /* ─── SMOOTH SCROLL FOR ANCHOR LINKS ─────────────────── */
  document.querySelectorAll('a[href^="#af-"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

})();
